var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconLinkOut(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 11C19.4 11 19 11.4 19 12L19 18C19 18.6 18.6 19 18 19L6 19C5.4 19 5 18.6 5 18L5 6C5 5.4 5.4 5 6 5L12 5C12.6 5 13 4.6 13 4 13 3.4 12.6 3 12 3L6 3C4.3 3 3 4.3 3 6L3 18C3 19.7 4.3 21 6 21L18 21C19.7 21 21 19.7 21 18L21 12C21 11.4 20.6 11 20 11Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 5L17.6 5 11.3 11.3C11.1 11.5 11 11.7 11 12 11 12.3 11.1 12.5 11.3 12.7 11.5 12.9 11.7 13 12 13 12.3 13 12.5 12.9 12.7 12.7L19 6.4 19 8C19 8.6 19.4 9 20 9 20.6 9 21 8.6 21 8L21 4C21 3.4 20.6 3 20 3L16 3C15.4 3 15 3.4 15 4 15 4.6 15.4 5 16 5Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLinkOut);
export default __webpack_public_path__ + "static/media/icon_link_out.19abe198.svg";
export { ForwardRef as ReactComponent };